export default __webpack_public_path__ + "static/media/bingoLogo.bd2fbef1.gif";